import Modal from '../../../../../commons/Modal/Modal';
import { ModalSizes } from '../../../../../commons/Modal/Modal.types';
import CommerciauxFiltersForm from './CommerciauxFiltersForm/CommerciauxFiltersForm';
import { CommerciauxFiltersModalProps } from './CommerciauxFiltersModal.types';

export default ({ ...props }: CommerciauxFiltersModalProps) => {
  return (
    <Modal
      className="dashboard__companies-filters"
      size={ModalSizes.Small}
      closeOnClickOutside
      {...props}>
      <h2 className="dashboard__companies-filters-title">Filtrer</h2>
      <CommerciauxFiltersForm closeModal={() => props.setOpen(false)} />
    </Modal>
  );
};
